"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var react_query_1 = require("react-query");
var react_redux_1 = require("react-redux");
var api_service_1 = require("../../../api/api_service");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../constants/appConstants");
var table_data_1 = require("../../../constants/table_data");
var array_helpers_1 = require("../../../utils/array_helpers");
var fe_services_1 = require("../fe_services");
var menu_constants_1 = require("../../../menuList/menu_constants");
var OnLeaveToday = function (_a) {
    var searchValue = _a.searchValue, selectedCities = _a.selectedCities, selectedCityIds = _a.selectedCityIds, selectedStateIds = _a.selectedStateIds, cityAndState = _a.cityAndState, CurrentPagelimit = _a.CurrentPagelimit, billingModule = _a.billingModule, isFilterButton = _a.isFilterButton;
    var feManagementFeatures = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.feManagement);
    var _b = React.useState(undefined), feOnleaveList = _b[0], setFeOnleaveList = _b[1];
    var startDate = new Date();
    var vendorId = (0, react_redux_1.useSelector)(function (state) { return state.user.vendorId; });
    var _c = React.useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = React.useState(1), pageCount = _d[0], setpageCount = _d[1];
    var _e = React.useState(0), totalPageCount = _e[0], setTotalPageCount = _e[1];
    var _f = React.useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var fetchOnLeaveToday = function (endPoint, payLoad, domain) {
        (0, fe_services_1.fetchLeavesList)(endPoint, payLoad, domain)
            .then(function (response) {
            var pageSize = CurrentPagelimit
                ? parseInt(CurrentPagelimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setErrorMessage("");
            setTotalPageCount(count);
            setFeOnleaveList(response.result);
            setTotalCount(response.count);
        })
            .catch(function (err) {
            setErrorMessage(err);
            setFeOnleaveList([]);
        });
    };
    var refetch = (0, react_query_1.useQuery)(['on-leave-today-fe', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = (0, array_helpers_1.createPayloadForOnLeaveToday)(appConstants_1.FE_USER_TYPES.onLeaveToday, searchValue, selectedCities, vendorId, {
            start_date: moment(startDate).format('YYYY-MM-DD'),
            end_date: moment(startDate).format('YYYY-MM-DD'),
        }, cityAndState, selectedCityIds, selectedStateIds, billingModule);
        payload.page = currentPage;
        payload.limit = CurrentPagelimit
            ? parseInt(CurrentPagelimit.value.toString())
            : 50;
        fetchOnLeaveToday(api_service_1.api_service.api_urls.onLeaveToday, payload, process.env.VENDOR_BASE_URL);
    }).refetch;
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var fetchTableColumns = function () {
        var tableColumns = table_data_1.default.FE_ONLEAVE_COLUMNS;
        if (feManagementFeatures[menu_constants_1.FEATURE_CONSTANTS.fe_billing_details]) {
            tableColumns = __spreadArray(__spreadArray([], table_data_1.default.FE_ONLEAVE_COLUMNS, true), table_data_1.default.BILLING_COLUMNS, true);
        }
        return tableColumns;
    };
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [isFilterButton]);
    return (React.createElement("div", { className: "unclickablerow custom-pagination-table" },
        React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: fetchTableColumns(), rows: feOnleaveList && feOnleaveList, errorMessage: errorMessage, pagination: false }),
        React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: feOnleaveList === null || feOnleaveList === void 0 ? void 0 : feOnleaveList.length, currentPageLimits: CurrentPagelimit === null || CurrentPagelimit === void 0 ? void 0 : CurrentPagelimit.value })));
};
exports.default = OnLeaveToday;
